<div *ngIf="!wordTemplate">
    <button (click)="uploadFile()" mat-flat-button color="primary">
        <mat-icon>autorenew</mat-icon>
        Datei hochladen
    </button>
</div>

<div *ngIf="wordTemplate" class="buttons">
    <div>
        <button (click)="previewFile()"><mat-icon>preview</mat-icon> Vorschau</button>
    </div>
    <div>
        <button (click)="downloadFile()"><mat-icon>file_download</mat-icon> Herunterladen</button>
    </div>
    <div>
        <button (click)="uploadFile()"><mat-icon>autorenew</mat-icon> Ersetzen</button>
    </div>
</div>
